import {useNavigate, useParams} from "react-router";
import type {GroupRepo, IngredientId} from "../../models/GroupRepo";
import {Box, Col} from "../../ui/Box";
import Button from "../../ui/Button";
import Icon from "../../ui/Icon";
import RefineIngredient from "./RefineIngredient";

const EditIngredient = ({groupRepo}: {groupRepo: GroupRepo}) => {
  const params = useParams<{ingredientId: string}>();
  const navigate = useNavigate();
  const onClose = () => navigate("..");

  return (
    <Col sp="12" height="_addItemDrawerHeight">
      <Box absolute right="0" top="0" pt="4" pr="4">
        <Button onClick={onClose} variant="tertiary">
          <Icon name="close" />
        </Button>
      </Box>
      <RefineIngredient
        id={params.ingredientId as IngredientId}
        onClose={onClose}
        groupRepo={groupRepo}
      />
    </Col>
  );
};

export default EditIngredient;
